const MASTERY_FLOW_KEY = "masteryFlowActive";

const safeSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

export const activateMasteryFlow = () => {
  const storage = safeSessionStorage();
  if (!storage) return;
  storage.setItem(MASTERY_FLOW_KEY, "true");
};

export const deactivateMasteryFlow = () => {
  const storage = safeSessionStorage();
  if (!storage) return;
  storage.removeItem(MASTERY_FLOW_KEY);
};

export const isMasteryFlowActive = () => {
  const storage = safeSessionStorage();
  if (!storage) return false;
  return storage.getItem(MASTERY_FLOW_KEY) === "true";
};
